import { v4 as uuid } from 'uuid';
import { ChartConfig } from "../chartV2/chart.typings";
import { ChartDrawingItem } from "../chartV2/drawingTools/drawing.interface";
import { WidgetConfig, WidgetDashboardConfig } from "../widgetDashboard/widgetDashboard.interface";

interface CopyLayoutParams {
    originalLayout: WidgetDashboardConfig;
    chartConfigs: Record<string, ChartConfig>;
    drawings: Record<string, ChartDrawingItem[]>;
}

export function copyLayoutData({
    originalLayout,
    chartConfigs,
    drawings
}: CopyLayoutParams): {
    newLayoutId: string;
    copiedLayout: WidgetDashboardConfig;
    newCharts: Record<string, ChartConfig>;
    newDrawings: Record<string, ChartDrawingItem[]>;
} {
    const newLayoutId = uuid().replace(/-/g, '').slice(0, 10);
    const chartIdMapping: Record<string, string> = {};
    const newCharts: Record<string, ChartConfig> = {};
    const newDrawings: Record<string, ChartDrawingItem[]> = {};
    const newWidgets: Record<number, WidgetConfig<any>> = {};

    Object.entries(originalLayout.widgets).forEach(([slotIdStr, widget]) => {
        const slotId = Number(slotIdStr);
        const oldChartId = widget?.settings?.chartId;

        if (!oldChartId || !chartConfigs[oldChartId]) {
            console.warn(`Skipping widget in slot ${slotId} due to missing or invalid chartId.`);
            return;
        }

        const newChartId = uuid().replace(/-/g, '').slice(0, 10);
        chartIdMapping[oldChartId] = newChartId;

        newWidgets[slotId] = {
            ...widget,
            slotId,
            settings: {
                ...widget.settings,
                chartId: newChartId
            }
        };
        newCharts[newChartId] = JSON.parse(JSON.stringify(chartConfigs[oldChartId]));
        newDrawings[newChartId] = drawings[oldChartId]
            ? JSON.parse(JSON.stringify(drawings[oldChartId]))
            : [];
    });

    const copiedLayout: WidgetDashboardConfig = {
        panes: JSON.parse(JSON.stringify(originalLayout.panes)),
        widgets: newWidgets,
        syncSettings: JSON.parse(JSON.stringify(originalLayout.syncSettings)),
        singleMode: originalLayout.singleMode ?? false
    };

    return {
        newLayoutId,
        copiedLayout,
        newCharts,
        newDrawings
    };
}
